import { createContext, createRef, type RefObject, useContext } from 'react';

export type TitleCommentRowContextValue = {
    readonly rowDataAttrs: Record<string, string>;
    readonly onRowClick?: () => void;
    readonly titleInputRef: RefObject<HTMLInputElement | null>;
};

const EMPTY_VALUE: TitleCommentRowContextValue = {
    rowDataAttrs: {},
    titleInputRef: createRef<HTMLInputElement>(),
};

export const TitleCommentRowContext = createContext<TitleCommentRowContextValue>(EMPTY_VALUE);

export const useTitleCommentRow = (): TitleCommentRowContextValue => useContext(TitleCommentRowContext);
